// extracted by mini-css-extract-plugin
export var center = "Remark-module--center--ff2e0";
export var remark = "Remark-module--remark--378aa";
export var remarkContent = "Remark-module--remarkContent--80b82";
export var remarkIcon = "Remark-module--remarkIcon--249a3";